import React from 'react'

export const LoadingWrapper: React.FC<{
  readonly isLoading: boolean | undefined
  readonly LoaderComponent?: React.FC
}> = ({ isLoading, children, LoaderComponent }) => {
  return <>{isLoading ? LoaderComponent ? <LoaderComponent /> : <></> : children}</>
}
